import React, { ComponentPropsWithRef } from 'react'
import { useTheme } from '@mui/material'

type Props = ComponentPropsWithRef<'div'> & {
    visible: boolean
    nCol?: number
}

const gridColsMap: Record<number, string> = {
    1: 'grid-cols-1',
    2: 'grid-cols-2',
    3: 'grid-cols-3',
    4: 'grid-cols-4',
    5: 'grid-cols-5',
    6: 'grid-cols-6',
    7: 'grid-cols-7',
    8: 'grid-cols-8',
    9: 'grid-cols-9',
    10: 'grid-cols-10',
    11: 'grid-cols-11',
    12: 'grid-cols-12'
}

export const StmsWrapper = (p: Props) => {
    const { className, visible = true, nCol = 1, ...rest } = p
    const gridColsClass = gridColsMap[nCol] || gridColsMap[1]
    const muiTheme = useTheme();
    return (
        // Outer div is the one growing and scrolling BUT zIndex is messed up with dnd -> "If your draggable item is within a scrollable container, we also recommend you use a <DragOverlay>, otherwise you'll need to set the draggable element to position: fixed yourself so the item isn't restricted to the overflow and stacking context of its scroll container, and can move without being affected by the scroll position of its container."
        // https://docs.dndkit.com/api-documentation/draggable/drag-overlay
        // <div className="flex-grow overflow-y-auto mx-2 mb-2">
        <div className="mx-2 my-2">
            {visible && (
                <div className={`p-2 gap-2 rounded-lg grid ${gridColsClass}`}
                style={{
                    backgroundColor: muiTheme.palette.secondary.main,
                }}
                >
                    {p.children}
                </div>
            )}
        </div>
    )
}
